import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import OccasionModal from "./Components/OccasionModal";

export default function AdminOccasion()
{
    const [occasions, setOccasions] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedOccasion, setSelectedOccasion] =
        useState<any>(null);

    const loadOccasions = async () => {

        const response =
            await api.get(
                '/occasions'
            );

        setOccasions(
            response.data
        );
    };

    useEffect(() => {

        loadOccasions();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedOccasion
        ) {

            await api.post(

                `/occasions/${selectedOccasion.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/occasions',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedOccasion(
            null
        );

        loadOccasions();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this occasion?'
            )
        ) {
            return;
        }

        await api.delete(
            `/occasions/${id}`
        );

        loadOccasions();
    };

    const moveOccasionUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...occasions];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setOccasions(
            updated
        );

        await api.post(
            '/occasions/reorder',
            {
                occasions:
                    updated.map(
                        (
                            occasion,
                            position
                        ) => ({
                            id:
                            occasion.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadOccasions();
    };

    const moveOccasionDown = async (
        index: number
    ) => {

        if (
            index >=
            occasions.length - 1
        ) {
            return;
        }

        const updated =
            [...occasions];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setOccasions(
            updated
        );

        await api.post(
            '/occasions/reorder',
            {
                occasions:
                    updated.map(
                        (
                            occasion,
                            position
                        ) => ({
                            id:
                            occasion.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadOccasions();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Occasions
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedOccasion(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Occasion
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {occasions.map(
                    (
                        occasion,
                        index
                    ) => (

                        <tr
                            key={
                                occasion.id
                            }
                        >

                            <td>
                                {
                                    occasion.name
                                }
                            </td>

                            <td>
                                {
                                    occasion.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveOccasionUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveOccasionDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedOccasion(
                                                occasion
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                occasion.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <OccasionModal

                    occasion={
                        selectedOccasion
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
